/*
 *
 * TestBatteries constants
 *
 */

export const LOAD_TEST_BATTERIES = "app/TestBatteries/LOAD_TEST_BATTERIES";
export const LOAD_TEST_BATTERIES_SUCCESS =
  "app/TestBatteries/LOAD_TEST_BATTERIES_SUCCESS";
export const LOAD_TEST_BATTERIES_ERROR =
  "app/TestBatteries/LOAD_TEST_BATTERIES_ERROR";

export const LOAD_TESTS = "app/TestBatteries/LOAD_TESTS";
export const LOAD_TESTS_SUCCESS = "app/TestBatteries/LOAD_TESTS_SUCCESS";
export const LOAD_TESTS_ERROR = "app/TestBatteries/LOAD_TESTS_ERROR";

export const LOAD_TESTMAKER_TESTS = "app/TestBatteries/LOAD_TESTMAKER_TESTS";
export const LOAD_TESTMAKER_TESTS_SUCCESS =
  "app/TestBatteries/LOAD_TESTMAKER_TESTS_SUCCESS";
export const LOAD_TESTMAKER_TESTS_ERROR =
  "app/TestBatteries/LOAD_TESTMAKER_TESTS_ERROR";

export const SAVE_BATTERY = "app/TestBatteries/SAVE_BATTERY";
export const SAVE_BATTERY_SUCCESS = "app/TestBatteries/SAVE_BATTERY_SUCCESS";
export const SAVE_BATTERY_ERROR = "app/TestBatteries/SAVE_BATTERY_ERROR";

export const EDIT_BATTERY = "app/TestBatteries/EDIT_BATTERY";
export const EDIT_BATTERY_SUCCESS = "app/TestBatteries/EDIT_BATTERY_SUCCESS";
export const EDIT_BATTERY_ERROR = "app/TestBatteries/EDIT_BATTERY_ERROR";

export const CHANGE_BATTERY_STATUS = "app/TestBatteries/CHANGE_BATTERY_STATUS";
export const CHANGE_BATTERY_STATUS_SUCCESS =
  "app/TestBatteries/CHANGE_BATTERY_STATUS_SUCCESS";
export const CHANGE_BATTERY_STATUS_ERROR =
  "app/TestBatteries/CHANGE_BATTERY_STATUS_ERROR";

export const GET_ASSOCIATED_JOBS = "app/TestBatteries/GET_ASSOCIATED_JOBS";
export const GET_ASSOCIATED_JOBS_SUCCESS =
  "app/TestBatteries/GET_ASSOCIATED_JOBS_SUCCESS";
export const GET_ASSOCIATED_JOBS_ERROR =
  "app/TestBatteries/GET_ASSOCIATED_JOBS_ERROR";

export const GET_UPDATE_TEST_BATTERY_INFO =
  "app/TestBatteries/GET_UPDATE_TEST_BATTERY_INFO";
export const GET_UPDATE_TEST_BATTERY_INFO_SUCCESS =
  "app/TestBatteries/GET_UPDATE_TEST_BATTERY_INFO_SUCCESS";
export const GET_UPDATE_TEST_BATTERY_INFO_ERROR =
  "app/TestBatteries/GET_UPDATE_TEST_BATTERY_INFO_ERROR";

export const UPDATE_TEST_BATTERY = "app/TestBatteries/UPDATE_TEST_BATTERY";
export const UPDATE_TEST_BATTERY_SUCCESS =
  "app/TestBatteries/UPDATE_TEST_BATTERY_SUCCESS";
export const UPDATE_TEST_BATTERY_ERROR =
  "app/TestBatteries/UPDATE_TEST_BATTERY_ERROR";

// A SubTest to Test Mapping that is used in the Test Batteries Modify and Create
/*
 * NO NEED TO ADD THE SUBTESTID MANUALLY!
 * Run `npm run generate` and select `newSubTest` to automate the adding new subTestId process
 * The script will automatically add the new subTestId to all the mappings being used in the repo
 * For more instructions: https://criteria.atlassian.net/wiki/spaces/FRO/pages/1562017793/Adding+SubTestIds+of+New+Assessments+in+Platform#MUST-READ%3A-Automating-the-Adding-SubTestId-Process-with-the-Plop-Generator
 */
export const subTestToTestMap = {
  1: 10,
  2: 10,
  3: 10,
  4: 12,
  5: 12,
  6: 12,
  7: 13,
  8: 12,
  9: 12,
  10: 14,
  11: 14,
  12: 14,
  13: 23,
  14: 25,
  15: 26,
  16: 25,
  17: 26,
  18: 23,
  19: 15,
  20: 24,
  21: 16,
  22: 16,
  23: 17,
  24: 18,
  25: 19,
  26: 20,
  27: 21,
  28: 22,
  29: 10,
  30: 29,
  31: 10,
  32: 12,
  33: 10,
  34: 30,
  35: 31,
  36: 10,
  37: 10,
  38: 10,
  39: 12,
  40: 10,
  41: 32,
  42: 33,
  43: 34,
  44: 10,
  45: 10,
  46: 10,
  47: 10,
  48: 10,
  49: 10,
  50: 10,
  51: 10,
  52: 31,
  53: 10,
  54: 10,
  55: 12,
  56: 10,
  57: 10,
  58: 35,
  59: 36,
  60: 10,
  61: 10,
  62: 10,
  63: 12,
  64: 12,
  65: 12,
  66: 37,
  67: 37,
  68: 37,
  69: 37,
  70: 12,
  71: 10,
  72: 38,
  73: 37,
  74: 37,
  75: 37,
  76: 39,
  77: 40,
  78: 41,
  79: 37,
  80: 12,
  81: 12,
  82: 12,
  83: 12,
  84: 37,
  85: 37,
  86: 37,
  87: 37,
  88: 34,
  92: 42,
  93: 37,
  94: 37,
  95: 43,
  96: 37,
  97: 37,
  98: 43,
  99: 43,
  100: 16,
  101: 10,
  102: 43,
  103: 43,
  104: 37,
  105: 37,
  106: 37,
  109: 44,
  110: 45,
  112: 44,
  113: 10,
  114: 12,
  115: 43,
  116: 37,
  117: 42,
  118: 37,
  119: 46,
  120: 46,
  121: 45,
  122: 45,
  123: 45,
  124: 10,
  125: 12,
  126: 43,
  127: 37,
  128: 39,
  129: 40,
  130: 41,
  131: 47,
  133: 37,
  134: 37,
  135: 49,
  136: 50,
  137: 51,
  138: 52,
  139: 52,
  140: 52,
  141: 52,
  142: 37,
  143: 52,
  144: 52,
  145: 52,
  146: 52,
  150: 52,
  151: 52,
  152: 34,
  153: 52,
  154: 52,
  156: 34,
  157: 34,
  155: 34,
  158: 52,
  159: 52,
  160: 52,
  161: 52,
  162: 52,
  163: 45,
  164: 45,
  165: 42,
  166: 52,
  167: 52,
  168: 52,
  169: 52,
  170: 52,
  171: 46,
  172: 46,
  173: 52,
  174: 52,
  175: 46,
  176: 46,
  177: 37,
  178: 37,
  179: 53,
  180: 53,
  181: 54,
  182: 55,
  183: 52,
  184: 52,
  185: 34,
  186: 34,
  187: 16,
  190: 57,
  191: 57,
  192: 57,
  193: 57,
  194: 57,
  195: 57,
  196: 57,
  197: 57,
  198: 57,
  199: 57,
  200: 57,
  201: 57,
  202: 57,
  203: 57,
  204: 57,
  205: 57,
  206: 57,
  207: 57,
  208: 57,
  209: 57,
  210: 57,
  211: 57,
  212: 57,
  213: 57,
  214: 57,
  215: 57,
  216: 34,
  217: 34,
  218: 34,
  219: 34,
  220: 34,
  221: 34,
  222: 37,
  223: 37,
  224: 31,
  225: 16,
  226: 16,
  227: 16,
  228: 34,
  229: 46,
  230: 46,
  231: 16,
  232: 16,
  233: 34,
  234: 16,
  235: 16,
  236: 16,
  237: 42,
  238: 34,
  240: 59,
  241: 59,
  242: 59,
  243: 59,
  // LAST LINE - DO NOT MOVE THIS COMMENT subTestToTestMap
};

/*
 * NO NEED TO ADD THE SUBTESTID MANUALLY!
 * Run `npm run generate` and select `newSubTest` to automate the adding new subTestId process
 * The script will automatically add the new subTestId to all the mappings being used in the repo
 * For more instructions: https://criteria.atlassian.net/wiki/spaces/FRO/pages/1562017793/Adding+SubTestIds+of+New+Assessments+in+Platform#MUST-READ%3A-Automating-the-Adding-SubTestId-Process-with-the-Plop-Generator
 */
export const subTestIdToSubTestName = {
  1: "Criteria Cognitive Aptitude Test",
  2: "CCAT 2",
  3: "Criteria Cognitive Aptitude Test",
  4: "Criteria Basic Skills Test",
  5: "CBST 2",
  6: "Criteria Basic Skills Test",
  7: "Criteria Personality Inventory",
  8: "Basic Math Skills Test",
  9: "Basic Verbal Skills Test",
  10: "MiniCog Rapid Assessment",
  11: "MRAB 2",
  12: "MRAB Spanish",
  13: "Criteria Attention Skills Test",
  14: "Working Memory",
  15: "Selective Attention",
  16: "Mental Rotation",
  17: "Divided Attention",
  18: "CAST Spanish",
  19: "Customer Service Aptitude Profile",
  20: "Sales Achievement Predictor",
  21: "Wiesen Test of Mechanical Aptitude",
  22: "Wiesen Test of Mechanical Aptitude - Spanish-Latin America (ES-LA)",
  23: "Typing Test",
  24: "Ten Key Test",
  25: "Excel 2003 (Simulation)",
  26: "Word 2003 (Simulation)",
  27: "Excel 2007",
  28: "Word 2007",
  29: "Criteria Cognitive Aptitude Test (UK)",
  30: "Employee Personality Profile",
  31: "Criteria Cognitive Aptitude Test",
  32: "Criteria Basic Skills Test Form B",
  33: "Criteria Cognitive Aptitude Test Form B",
  34: "Computer Literacy and Internet Knowledge Test",
  35: "Workplace Productivity Profile",
  36: "Criteria Cognitive Aptitude Test",
  37: "Criteria Cognitive Aptitude Test",
  38: "Criteria Cognitive Aptitude Test",
  39: "Criteria Basic Skills Test Spanish",
  40: "Criteria Cognitive Aptitude Test",
  41: "Excel 2010",
  42: "Word 2010",
  43: "Employee Personality Profile",
  44: "Criteria Cognitive Aptitude Test (CCAT Rx)",
  45: "Criteria Cognitive Aptitude Test (UK)",
  46: "CCAT C",
  47: "CCAT D",
  48: "CCAT E",
  49: "CCAT F",
  50: "CCAT G",
  51: "CCAT Item Validation 2013",
  52: "WPP Spanish",
  53: "CCAT D Item Validation",
  54: "CCAT E Item Validation",
  55: "Criteria Basic Skills Test (CA)",
  56: "Criteria Cognitive Aptitude Test (CA)",
  57: "Criteria Cognitive Aptitude Test",
  58: "Excel 2013",
  59: "Word 2013",
  60: "CCAT H",
  61: "CCAT I",
  62: "CCAT J",
  63: "CBST 4",
  64: "CBST 5",
  65: "Criteria Basic Skills Test Form B (CBST Rx)",
  66: "Aptitude Item Tester",
  67: "Universal Cognitive Aptitude Test",
  68: "Universal Cognitive Aptitude Test (Spanish)",
  69: "Universal Cognitive Aptitude Test (French)",
  70: "Criteria Basic Skills Test (EU)",
  71: "Criteria Cognitive Aptitude Test (UK)",
  72: "PowerPoint 2013",
  73: "Universal Cognitive Aptitude Test (Chinese)",
  74: "Universal Cognitive Aptitude Test (Japanese)",
  75: "Universal Cognitive Aptitude Test (Hindi)",
  76: "Excel 2016",
  77: "Word 2016",
  78: "PowerPoint 2016",
  79: "Universal Cognitive Aptitude Test (German)",
  80: "CBST 6",
  81: "CBST 7",
  82: "CBST 8",
  83: "Criteria Basic Skills Test",
  84: "Universal Cognitive Aptitude Test (Extended)",
  85: "Universal Cognitive Aptitude Test - Polish (PL)",
  86: "Universal Cognitive Aptitude Test (Portuguese)",
  87: "Universal Cognitive Aptitude Test (Burmese)",
  88: "Employee Personality Profile (Spanish - Castilian)",
  89: "Employee Personality Profile (French)",
  90: "Employee Personality Profile (Portuguese)",
  91: "Employee Personality Profile (Croatian)",
  92: "General Aptitude Mobile Evaluation",
  93: "Universal Cognitive Aptitude Test (Russian)",
  94: "Universal Cognitive Aptitude Test (Arabic)",
  95: "Criteria Mechanical Reasoning Assessment",
  96: "Universal Cognitive Aptitude Test - Swedish (SV)",
  97: "Universal Cognitive Aptitude Test (Macedonian)",
  98: "Employee Personality Profile",
  99: "Employee Personality Profile (German)",
  100: "Wiesen Test of Mechanical Aptitude",
  101: "Criteria Cognitive Aptitude Test",
  102: "Criteria Mechanical Reasoning Test (Spanish)",
  103: "Criteria Mechanical Reasoning Test (French)",
  104: "Universal Cognitive Aptitude Test - Czech (CS)",
  105: "Universal Cognitive Aptitude Test - Dutch (NL)",
  106: "Universal Cognitive Aptitude Test (Ukrainian)",
  109: "Emotify",
  110: "Cognify",
  111: "Criteria Basic Skills Test (CBST Rx)",
  112: "Emotify Rx",
  113: "Criteria Cognitive Aptitude Test",
  114: "Criteria Basic Skills Test",
  115: "Criteria Mechanical Reasoning Assessment",
  116: "Universal Cognitive Aptitude Test",
  117: "General Aptitude Mobile Evaluation",
  118: "Universal Cognitive Aptitude Test (Khmer)",
  119: "Workplace Safety Profile - Long",
  120: "Workplace Safety Profile",
  121: "Cognify",
  122: "Cognify Rx",
  123: "Cognify Rx",
  124: "Criteria Cognitive Aptitude Test Rx",
  125: "Criteria Basic Skills Test Rx",
  126: "Criteria Mechanical Reasoning Assessment Rx",
  127: "Universal Cognitive Aptitude Test Rx",
  128: "Excel 2016",
  129: "Word 2016",
  130: "PowerPoint 2016",
  131: "Criteria Cognitive Aptitude Test (CCAT cAT)",
  132: "Illustrait",
  133: "Universal Cognitive Aptitude Test (Chinese)",
  134: "Universal Cognitive Aptitude Test (Portuguese)",
  135: "Computer Literacy and Internet Knowledge Test",
  136: "Workplace Alignment Assessment",
  137: "Emotify",
  138: "UCognify",
  139: "UCognify",
  140: "UCognify de",
  141: "UCognify es-es",
  142: "UCATi",
  143: "UCognify pt-br",
  144: "UCognify pt-br",
  145: "UCognify fr-ca",
  146: "UCognify fr-ca",
  150: "UCognify pt-pt",
  151: "UCognify pt-pt",
  152: "Employee Personality Profile (Spanish - Latin America)",
  153: "UCognify es-la",
  154: "UCognify es-la",
  156: "Employee Personality Profile (Chinese - Simplified)",
  157: "Employee Personality Profile (Japanese)",
  155: "Employee Personality Profile (Portuguese - Brazilian)",
  158: "UCognify de",
  159: "UCognify ko",
  160: "UCognify ko",
  161: "UCognify tr",
  162: "UCognify tr",
  163: "Cognify tr",
  164: "Cognify tr",
  165: "General Aptitude Mobile Evaluation - Spanish-Latin America (ES-LA)",
  166: "UCognify fr-fr",
  167: "UCognify fr-fr",
  168: "UCognify es-es",
  169: "UCognify ja",
  170: "UCognify ja",
  171: "Workplace Safety Profile - Spanish-Latin America (ES-LA)",
  172: "Workplace Safety Profile - Long - Spanish-Latin America (ES-LA)",
  173: "UCognify zh-cn",
  174: "UCognify zh-cn",
  175: "Workplace Safety Profile - Portuguese-Brazil (PT-BR)",
  176: "Workplace Safety Profile - Long - Portuguese-Brazil (PT-BR)",
  177: "UCATfr-ca",
  178: "UCATes-la",
  179: "Excel 365 Interactive",
  180: "Excel 365",
  181: "Word 365",
  182: "PowerPoint 365",
  183: "UCognify it",
  184: "UCognify it",
  185: "EPPit",
  186: "EPPfr-fr",
  187: "Wiesen Test of Mechanical Aptitude - French-Canada (FR-CA)",
  188: "Cognitive Aptitude Test - DFR Use Only",
  189: "Cognitive Aptitude Test - DFR Use Only",
  190: "Criteria Language Proficiency Test - English",
  191: "Criteria Language Proficiency Test Express - English",
  192: "Criteria Language Proficiency Test - English; Spanish-Spain (ES-ES)",
  193: "Criteria Language Proficiency Test - English; Spanish-Latin America (ES-LA)",
  194: "Criteria Language Proficiency Test - English; French-France (FR-FR)",
  195: "Criteria Language Proficiency Test - English; French-Canada (FR-CA)",
  196: "Criteria Language Proficiency Test - English; Portuguese-Portugal (PT-PT)",
  197: "Criteria Language Proficiency Test - English; Portuguese-Brazil (PT-BR)",
  198: "Criteria Language Proficiency Test - English; Chinese-Simplified (ZH-CN)",
  199: "Criteria Language Proficiency Test - English; German (DE)",
  200: "Criteria Language Proficiency Test - English; Italian (IT)",
  201: "Criteria Language Proficiency Test - English; Japanese (JA)",
  202: "Criteria Language Proficiency Test - English; Korean (KO)",
  203: "Criteria Language Proficiency Test - English; Turkish (TR)",
  204: "Criteria Language Proficiency Test Express - English; Spanish-Spain (ES-ES)",
  205: "Criteria Language Proficiency Test Express - English; Spanish-Latin America (ES-LA)",
  206: "Criteria Language Proficiency Test Express - English; French-France (FR-FR)",
  207: "Criteria Language Proficiency Test Express - English; French-Canada (FR-CA)",
  208: "Criteria Language Proficiency Test Express - English; Portuguese-Portugal (PT-PT)",
  209: "Criteria Language Proficiency Test Express - English; Portuguese-Brazil (PT-BR)",
  210: "Criteria Language Proficiency Test Express - English; Chinese-Simplified (ZH-CN)",
  211: "Criteria Language Proficiency Test Express - English; German (DE)",
  212: "Criteria Language Proficiency Test Express - English; Italian (IT)",
  213: "Criteria Language Proficiency Test Express - English; Japanese (JA)",
  214: "Criteria Language Proficiency Test Express - English; Korean (KO)",
  215: "Criteria Language Proficiency Test Express - English; Turkish (TR)",
  216: "Employee Personality Profile - Dutch (NL)",
  217: "Employee Personality Profile - Polish (PL)",
  218: "Employee Personality Profile - Romanian (RO)",
  219: "Employee Personality Profile - Czech (CS)",
  220: "Employee Personality Profile - Danish (DA)",
  221: "Employee Personality Profile - Swedish (SV)",
  222: "Universal Cognitive Aptitude Test - Danish (DA)",
  223: "Universal Cognitive Aptitude Test - Romanian (RO)",
  224: "Workplace Productivity Profile - Portuguese-Brazil (PT-BR)",
  225: "Wiesen Test of Mechanical Aptitude - French-France (FR-FR)",
  226: "Wiesen Test of Mechanical Aptitude - Spanish-Spain (ES-ES)",
  227: "Wiesen Test of Mechanical Aptitude",
  228: "Employee Personality Profile",
  229: "Workplace Safety Profile - French-Canada (FR-CA)",
  230: "Workplace Safety Profile - Long - French-Canada (FR-CA)",
  231: "Wiesen Test of Mechanical Aptitude - German (DE)",
  232: "Wiesen Test of Mechanical Aptitude - Polish (PL)",
  233: "Employee Personality Profile - Slovak (SK)",
  234: "Wiesen Test of Mechanical Aptitude - Italian (IT)",
  235: "Wiesen Test of Mechanical Aptitude - Czech (CS)",
  236: "Wiesen Test of Mechanical Aptitude - Slovak (SK)",
  237: "General Aptitude Mobile Evaluation - French-Canada (FR-CA)",
  238: "Employee Personality Profile - Arabic (AR)",
  240: "Criteria Think Reason Solve Express",
  241: "Criteria Think Reason Solve Express; Spanish-Latin America (ES-LA)",
  242: "Criteria Think Reason Solve Express; French-Canada (FR-CA)",
  243: "Criteria Think Reason Solve Express; Portuguese-Brazil (PT-BR)",
  // LAST LINE - DO NOT MOVE THIS COMMENT subTestIdToSubTestName
};
